import { createContext, useContext } from 'react'

export type AppContextValue = {
  me: Record<string, unknown> | null
  openSupportWidget: () => void
}

export const AppContext = createContext<AppContextValue | null>(null)

export function useAppContext() {
  const ctx = useContext(AppContext)

  if (!ctx)
    throw new Error('useAppContext must be used within <AppContextProvider>')
  return ctx
}
